module.exports = __webpack_public_path__ + "img/ico_btn_notice_on.5dc1dc5.svg";